import { ca } from '@cian/analytics';

import { IProduct } from '../../../types/analytics';

export function trackAcceptWarning(product: IProduct) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ct_informer',
    action: 'click',
    label: 'got_it',
    products: [product],
  });
}
